<script setup>
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import CampaignCard from 'dashboard/components-next/Campaigns/CampaignCard/CampaignCard.vue';

defineProps({
  title: {
    type: String,
    default: '',
  },
  subtitle: {
    type: String,
    default: '',
  },
});

const EMAIL_CAMPAIGN_EMPTY_STATE_CONTENT = [
  {
    id: 1,
    title: 'Welcome Email Campaign',
    message:
      'Welcome new subscribers with a personalized email introducing your brand...',
    enabled: true,
    campaign_status: 'completed',
    sender: { name: 'Marketing Team' },
    inbox: { name: 'Newsletter', channel_type: 'Channel::Email' },
    scheduled_at: new Date(Date.now() - 86400000).toISOString(),
  },
  {
    id: 2,
    title: 'Product Launch Announcement',
    message:
      'Exciting news! We are launching our new product line next week...',
    enabled: true,
    campaign_status: 'active',
    sender: { name: 'Sales Team' },
    inbox: { name: 'Support Email', channel_type: 'Channel::Email' },
    scheduled_at: new Date(Date.now() + 86400000).toISOString(),
  },
];
</script>

<template>
  <EmptyStateLayout :title="title" :subtitle="subtitle">
    <template #empty-state-item>
      <div class="flex flex-col gap-4 p-px">
        <CampaignCard
          v-for="campaign in EMAIL_CAMPAIGN_EMPTY_STATE_CONTENT"
          :key="campaign.id"
          :title="campaign.title"
          :message="campaign.message"
          :is-enabled="campaign.enabled"
          :status="campaign.campaign_status"
          :sender="campaign.sender"
          :inbox="campaign.inbox"
          :scheduled-at="campaign.scheduled_at"
        />
      </div>
    </template>
  </EmptyStateLayout>
</template>
